import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import {
  getOrderStatusOption,
  orderSteps,
  type OrderStepValue,
} from "./orderSteps";

type StatusSelectorProps = {
  status: OrderStepValue | null;
  onStatusChange: (status: OrderStepValue | null) => void;
};

export default function StatusSelector({
  status,
  onStatusChange,
}: StatusSelectorProps) {
  const selectedOption = getOrderStatusOption(status);

  return (
    <Listbox value={status} onChange={onStatusChange}>
      <ListboxButton className="flex flex-1 md:flex-none md:min-w-36 items-center justify-between gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-950 outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer">
        <span className="truncate">{selectedOption.label}</span>
        <ChevronDownIcon className="size-5 shrink-0 text-gray-500" />
      </ListboxButton>
      <ListboxOptions
        anchor="bottom end"
        className="z-20 mt-1 min-w-(--button-width) rounded-xl border border-gray-200 bg-white p-1 shadow-lg outline-none"
      >
        {orderSteps.map((opt, index) => (
          <ListboxOption
            key={index}
            value={opt.value}
            className="cursor-pointer select-none rounded-lg px-3 py-2 text-sm data-focus:bg-blue-50 data-focus:text-blue-500"
          >
            {opt.label}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </Listbox>
  );
}
